/**
 * `TotalHours` and `TotalHeadcount` are tracking-only: no target value. Their
 * stored `target_value` is 0, which `expectedByNow` reads as no commitment —
 * exclude them explicitly; see `utils/trackingTargets`.
 */
export var ProjectLabourHourCommitmentType;
(function (ProjectLabourHourCommitmentType) {
    ProjectLabourHourCommitmentType["Fixed"] = "project-labour-hour-commitment-type_fixed";
    ProjectLabourHourCommitmentType["Ratio"] = "project-labour-hour-commitment-type_ratio";
    ProjectLabourHourCommitmentType["Headcount"] = "project-labour-hour-commitment-type_headcount";
    ProjectLabourHourCommitmentType["HeadcountRatio"] = "project-labour-hour-commitment-type_headcount-ratio";
    ProjectLabourHourCommitmentType["TotalHours"] = "project-labour-hour-commitment-type_total-hours";
    ProjectLabourHourCommitmentType["TotalHeadcount"] = "project-labour-hour-commitment-type_total-headcount";
})(ProjectLabourHourCommitmentType || (ProjectLabourHourCommitmentType = {}));
export var LabourHourFactorCountingMethod;
(function (LabourHourFactorCountingMethod) {
    LabourHourFactorCountingMethod["AllFactorsCombined"] = "labour-hour-factor-counting-method_all-factors-combined";
    LabourHourFactorCountingMethod["AnyMatchingFactor"] = "labour-hour-factor-counting-method_any-matching-factor";
})(LabourHourFactorCountingMethod || (LabourHourFactorCountingMethod = {}));
export var LabourHourTargetDenominator;
(function (LabourHourTargetDenominator) {
    LabourHourTargetDenominator["TotalWorkHours"] = "labour-hours-target-denominator_total-work-hours";
    LabourHourTargetDenominator["TotalHoursTrade"] = "labour-hours-target-denominator_total-bep-hours-trade";
    LabourHourTargetDenominator["TotalHoursNonTrade"] = "labour-hours-target-denominator_total-bep-hours-non-trade";
    LabourHourTargetDenominator["TotalHoursManagement"] = "labour-hours-target-denominator_total-bep-hours-management";
    LabourHourTargetDenominator["ACTHours"] = "labour-hours-target-denominator_act-hours";
    // Queensland
    LabourHourTargetDenominator["ProjectTrainingTargetHours"] = "labour-hours-target-denominator_project-training-target-hours";
})(LabourHourTargetDenominator || (LabourHourTargetDenominator = {}));
